var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"stepper-step",class:_vm.classes},_vm.$listeners),[_c('div',{staticClass:"stepper-step__point"},[_vm._t("default")],2),_c('span',{staticClass:"stepper-step__label"},[_vm._t("label")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }